import {writable} from "svelte/store";
import {InfoCircleSolid} from "flowbite-svelte-icons";

export const globalToast = writable({
    icon: InfoCircleSolid,
    open: false,
    content: "Toast",
    color: "green",
    timed(content: string, duration: number = 3000, icon: any = InfoCircleSolid) {
        globalToast.update((toast:any) => {
            toast.content = content
            toast.icon = icon
            toast.open = true
            return toast;
        })

        setTimeout(() => {
            globalToast.update((toast:any) => {
                toast.open = false
                return toast
            })
        }, duration)
    }
})